import { useState } from "react";
import { useCart } from "../../../hooks/useCart";
import { TagStyleType } from "../../../models/base/TagStyleType";
import ImageModalTrigger from "../ImageModalTrigger";
import TagTypes from "./TagTypes";
import { Product } from "./types";
import { ProductVariantDTO } from "../../../models/local/local.response";
import { ProductVariantView } from "../../client/shared/ProductVariantView";

interface ProductCardType4Props {
    primaryColor?: string;
    tagTypes?: TagStyleType;
    product?: Product;
    cart: ReturnType<typeof useCart>;
    showAddToCartButton: boolean;
}

export default function ProductCardType4({ primaryColor, tagTypes, product, cart, showAddToCartButton }: ProductCardType4Props) {

    const [isProductVariantViewOpen, setIsProductVariantViewOpen] = useState(false);

    if (!product) {
        return <></>;
    }

    const minPrice = (productVariants?: ProductVariantDTO[]) => {
        if (!productVariants)
            return null;

        return productVariants.length > 0
            ? productVariants.reduce((min, current) => current.price < min.price ? current : min).price
            : null;
    }

    return (
        <>
            {isProductVariantViewOpen && (
                <ProductVariantView
                    product={product}
                    onClose={() => setIsProductVariantViewOpen(false)}
                    primaryColor={primaryColor}
                    tagTypes={tagTypes}
                    cart={cart}
                />
            )}

            <div className="client-product-div prod-style-4">

                {product.imageUrl && (
                    <div className="client-product-image-div prod-style-4">
                        {product.imageUrl && (
                            <ImageModalTrigger
                                url={product.imageUrl + "@lg.webp" || ""}
                                altText={product.name + "@lg.webp" || ""}
                                showImageIcon={true}
                            >
                                <img loading="lazy" src={product.imageUrl + "@lg.webp" || ""} alt={product.name || ""} className="client-product-image prod-style-4" />
                            </ImageModalTrigger>
                        )}
                        {product.isNew && (
                            <div className="client-product-new-tag-block prod-style-4">
                                <div className="client-product-new-tag-div absolute-top prod-style-4" style={{ background: primaryColor }}>
                                    <div>NOVO</div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="client-product-info-and-button-div prod-style-4">
                    <div className="client-product-info-block">
                        <div className="client-product-info-div prod-style-4">
                            <div className="div-block-18">
                                <div className="client-product-name prod-style-4">{product.name}</div>
                                <div className="client-product-price-div">
                                    {product.productVariants && product.productVariants.length === 1 && product.productVariants[0].oldPrice !== undefined && product.productVariants[0].oldPrice !== null ? (
                                        <div className="client-product-price-old-price-div">
                                            <div className="client-product-price-old-price">{product.productVariants[0].oldPrice} rsd</div>
                                        </div>
                                    ) : null}
                                    {product.productVariants && product.productVariants.length > 1 ? (
                                        <div className="client-product-price" style={{ color: primaryColor }}>od {minPrice(product.productVariants)} RSD</div>
                                    ) : (
                                        <div className="client-product-price" style={{ color: primaryColor }}>{minPrice(product.productVariants)} RSD</div>
                                    )}
                                </div>
                            </div>
                            <div className="client-product-description">{product.description}</div>
                            <div className="client-product-description2 prod-style-4">{product.description2}</div>

                            <TagTypes
                                style={tagTypes}
                                primaryColor={primaryColor}
                                tags={product.tags}
                            />

                        </div>
                    </div>

                    {showAddToCartButton && (
                        product.productVariants && product.productVariants.length === 1 ? (
                            cart.getProductVariantQuantity(product.productVariants[0].id) > 0 ? (
                                <div className="client-product-info-and-button-quantity-div" style={{ color: primaryColor }}>
                                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            cart.changeProductVariantQuantity(
                                                product.productVariants[0].id,
                                                cart.getProductVariantQuantity(product.productVariants[0].id) - 1
                                            );
                                        }}
                                    >
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14" />
                                    </svg>

                                    <div className="client-product-info-and-button-quantity-number" style={{ color: primaryColor, fontWeight: "bold" }}>
                                        {cart.getProductVariantQuantity(product.productVariants[0].id)}
                                    </div>

                                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            cart.changeProductVariantQuantity(
                                                product.productVariants[0].id,
                                                cart.getProductVariantQuantity(product.productVariants[0].id) + 1
                                            );
                                        }}
                                    >
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5" />
                                    </svg>

                                </div>

                            ) : (
                                <div className="client-product-button prod-style-4"
                                    style={{ backgroundImage: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 100%)", backgroundColor: primaryColor, color: "white" }}
                                    onClick={() => cart.addProductVariant({
                                        ...product,
                                        quantity: 1,
                                        selectedVariant: product.productVariants[0]
                                    })}>
                                    <div>Dodaj u korpu</div>
                                </div>

                            )

                        ) : (
                            <div className="client-product-button prod-style-4"
                                style={{ backgroundImage: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 100%)", backgroundColor: primaryColor, color: "white" }}
                                onClick={() => setIsProductVariantViewOpen(true)}>
                                <div>Izaberi varijantu</div>
                            </div>

                        )
                    )}

                </div>

                {product.isNew && !product.imageUrl && (
                    <div className="client-product-new-tag-block prod-style-4">
                        <div className="client-product-new-tag-div absolute-top prod-style-4" style={{ background: primaryColor }}>
                            <div>NOVO</div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
}